<template>
  <div>
    <div class="animates-items mb16">
      <cx-background :background.sync="backgroundVariable" imgType="10" class="mt16" />
    </div>
    <div class="animates-items">
      <slider-and-input
        class="mb16"
        inputWidth="small"
        inputHeight="small"
        :value.sync="animateDataVal.animateDuration"
        title="持续"
        titlePosition="allInOneLine"
        :sliderMax="10000"
        suffix="ms"
      />
      <slider-and-input
        class="mb16"
        inputWidth="small"
        inputHeight="small"
        :value.sync="animateDataVal.animateDelay"
        title="延迟"
        titlePosition="allInOneLine"
        :sliderMax="10000"
        suffix="ms"
      />
      <div class="verticallyCenter">
        <div class="mr16">触发</div>
        <div class="content">
          <el-radio-group v-model="animateDataVal.animationIterationCount">
            <el-radio
              v-for="(option, index) in triggerstyles.list"
              :key="index"
              :label="option.value"
              :disabled="option.disabled"
              >{{ option.title }}</el-radio
            >
          </el-radio-group>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getAttrById, handleFindLayoutComponentOptionsCols } from "../../../../../utils"

export default {
  name: "opacity-setting",
  components: {},
  props: {
    animateData: {
      type: Object
    },
    options: {
      type: Object
    }
  },
  data() {
    return {
      triggerstyles: {
        type: "触发次数",
        checked: "单次触发",
        list: [
          {
            value: 1,
            disabled: false,
            title: "单次触发"
          },
          {
            value: 2,
            disabled: false,
            title: "多次触发"
          }
        ]
      }
    }
  },
  computed: {
    ids() {
      return this.$store.state.states.activeID
    },
    animateDataVal: {
      get() {
        return this.animateData
      },
      set(newVal) {
        this.$emit("update:animateData", newVal)
      }
    },
    backgroundVariable: {
      get() {
        let defaultBg = [
          {
            type: "color",
            label: "颜色",
            isThemeColor: false,
            color: "rgba(0,0,0,0)"
          }
        ]
        if (!this.animateDataVal.background || this.animateDataVal.background.length === 0) {
          // defaultBg = JSON.parse(JSON.stringify(this.options.background))
          this.animateDataVal.background = defaultBg
        } else {
          defaultBg = this.animateDataVal.background
        }
        return this.animateDataVal.background
      },
      set(newVal) {
        this.animateDataVal.background = newVal
        this.getBgStyle(newVal)
      }
    }
  },
  mounted() {},
  methods: {
    getBgStyle(curBackground) {
      let conatinerBg = {
        backgroundImage: "",
        backgroundSize: "",
        backgroundPosition: "",
        backgroundRepeat: ""
      }
      if (
        !curBackground ||
        !Array.isArray(curBackground) ||
        (Array.isArray(curBackground) && curBackground.length === 0)
      ) {
        curBackground = [
          {
            type: "color",
            label: "颜色",
            isThemeColor: this.options.hasOwnProperty("bgColorIsThemeColor") ? this.options.bgColorIsThemeColor : false,
            color: this.options.bgColor
          }
        ]
      }
      curBackground.forEach(bg => {
        switch (bg.type) {
          case "img":
            let dot1 = conatinerBg.backgroundImage.length > 0 ? "," : ""
            conatinerBg.backgroundImage += `${dot1}url(${bg.imgUrl})`
            conatinerBg.backgroundSize = bg.clipSize
            conatinerBg.backgroundPosition = bg.alignType
            conatinerBg.backgroundRepeat = bg.repeatType
            break
          case "color":
            conatinerBg.backgroundColor = bg.isThemeColor ? "var_BackgroundColor_page.themeColor" : bg.color
            break
          case "linearGradient":
            let tmp = []
            if (bg.data.stops.length > 0) {
              bg.data.stops.forEach(item => {
                tmp.push(item[0] + " " + item[1] * 100 + "%")
              })
              let dot = conatinerBg.backgroundImage.length > 0 ? "," : ""
              conatinerBg.backgroundImage += dot + "linear-gradient(" + bg.data.angle + "deg," + tmp.join(",") + ")"
            }
            break
          case "radialGradient":
            break
          default:
        }
      })
      let triggerType = this.animateDataVal.triggerType
      let colorName = `${triggerType}Background`
      let backgroundStyle = `${conatinerBg.backgroundImage} ${conatinerBg.backgroundRepeat} ${conatinerBg.backgroundPosition}`
      this.animateDataVal.variable[colorName] = backgroundStyle
      this.animateDataVal.variable[colorName + "Color"] = conatinerBg.backgroundColor
      this.animateDataVal.variable[colorName + "Size"] = conatinerBg.backgroundSize
        ? `${conatinerBg.backgroundSize}`
        : ""
    }
  }
}
</script>

<style lang="scss" scoped></style>
